import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import {
  Artwork,
  Artworks,
  ArtistHome,
  Dashboard,
  ExportArtists,
  ExportArtworks,
  ExportSales,
  Sales,
  SelectFiles,
  SignOut,
  Upload,
  User
} from 'containers'
import { UserRole } from 'api/enums'

import * as routes from 'routes'

const Routes = ({ role }) => (
  <Switch>

    { role === UserRole.MANAGER && [
      <Route
        key='dashboard'
        exact path={routes.dashboard()}
        component={Dashboard}
      />,
      <Route
        key='artwork'
        path={routes.exportArtwork()}
        component={Artwork}
      />,
      <Route
        key='export-artworks'
        exact path={routes.exportArtworks()}
        component={ExportArtworks}
      />,
      <Route
        key='export-sales'
        path={routes.exportSales()}
        component={ExportSales}
      />,
      <Route
        key='export-artists'
        path={routes.exportArtists()}
        component={ExportArtists}
      />
    ] }

    { role === UserRole.ARTIST && [
      <Route
        key='artist-home'
        exact path={routes.artistHome()}
        component={ArtistHome}
      />,
      <Route
        key='artwork'
        path={routes.artwork()}
        component={Artwork}
      />,
      <Route
        key='artworks'
        path={routes.artworks()}
        component={Artworks}
      />,
      <Route
        key='sales'
        path={routes.sales()}
        component={Sales}
      />,
      <Route
        key='select-files'
        path={routes.selectFiles()}
        component={SelectFiles}
      />,
      <Route
        key='upload'upload
        path={routes.upload()}
        component={Upload}
      />
    ] }

    <Route key='user' path={routes.account()} component={User} />,

    <Route path={routes.signOut()} component={SignOut} />

    { role === UserRole.MANAGER && (
      <Redirect to={routes.dashboard()} />
    ) }

    { role === UserRole.ARTIST && (
      <Redirect to={routes.artistHome()} />
    ) }

  </Switch>
)

export default Routes



// WEBPACK FOOTER //
// ./src/containers/PrivateRoot/Routes.js